import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useCommitteeDelete } from '../model/CommitteeQuery';

interface CommitteeDeleteButtonProps {
  committeeId: Id;
}

export function CommitteeDeleteButton({ committeeId }: CommitteeDeleteButtonProps) {
  const mutation = useCommitteeDelete(committeeId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
